const de = {
  "lang.de": "DE",
  "lang.th": "ไทย",
  "lang.switch": "Sprache",

  "common.loading": "Laden…",
  "common.logout": "Abmelden",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.all": "Alle",
  "common.search": "Suchen",
  "common.reset": "Zurücksetzen",
  "common.back": "← Zurück",
  "common.next": "Weiter →",
  "common.close": "Schließen",
  "common.cancel": "Abbrechen",
  "common.free": "Kostenfrei",
  "common.minutes": "Min.",
  "common.noEntries": "Keine Einträge.",
  "common.toWebsite": "Zur Website",
  "common.toWebsiteAria": "Zur Website",

  "brand.team": "Dr. Hoffmann · Admin",

  "tabs.manual": "Manuelle Buchung",
  "tabs.revenue": "Manueller Umsatz",
  "tabs.comparison": "Umsatzvergleich",
  "tabs.overview": "Übersicht",
  "tabs.calendar": "Kalender",
  "tabs.bookings": "Buchungen",
  "tabs.availability": "Verfügbarkeit",
  "tabs.customers": "Kunden",
  "tabs.navAria": "Dashboard-Bereiche",
  "tabs.more": "Mehr",
  "tabs.menuOpen": "Weitere Bereiche öffnen",
  "tabs.menuClose": "Menü schließen",

  "manual.formLead":
    "Termin für einen Kunden anlegen. Gib die E-Mail-Adresse ein und wähle die gleiche Leistung wie auf /buchen. Der Kunde muss kein Konto haben.",
  "manual.customerTitle": "Kundendaten",
  "manual.firstName": "Vorname",
  "manual.lastName": "Nachname",
  "manual.email": "E-Mail",
  "manual.phone": "Telefon",
  "manual.serviceTitle": "Leistung",
  "manual.service": "Leistung",
  "manual.servicePlaceholder": "Leistung auswählen …",
  "manual.deliveryLabel": "Ort",
  "manual.deliveryStudio": "Im Studio",
  "manual.deliveryOnsite": "Vor Ort",
  "manual.applyTravelFee": "Anfahrtspauschale (39 €)",
  "manual.useCustomPrice": "Preis manuell setzen",
  "manual.customPrice": "Preis (€)",
  "manual.customPriceActive": "manuell",
  "manual.customPriceInvalid": "Bitte einen gültigen Preis angeben.",
  "manual.customPriceTooHigh": "Der Preis darf maximal 1.000 € betragen.",
  "manual.priceLabel": "Preis",
  "manual.free": "Kostenfrei",
  "manual.dateTitle": "Datum & Uhrzeit",
  "manual.arranged": "Termin wird telefonisch abgestimmt (nach Vereinbarung).",
  "manual.slotsLoading": "Verfügbare Zeiten werden geladen…",
  "manual.slotsEmpty":
    "An diesem Tag sind keine passenden Termine verfügbar. Bitte einen anderen Tag wählen.",
  "manual.addressTitle": "Adresse (Vor Ort)",
  "manual.companyName": "Name / Firma",
  "manual.address": "Adresse",
  "manual.addressNotes": "Hinweise zur Adresse",
  "manual.voucherTitle": "Gutschein",
  "manual.hasVoucher": "Kunde hat einen Gutschein (Anfahrt entfällt)",
  "manual.voucherTerms": "Gutschein wird zum Termin mitgebracht.",
  "manual.detailsTitle": "Zahlung & Notizen",
  "manual.payment": "Zahlungsart",
  "manual.paymentOnSite": "Vor Ort",
  "manual.paymentLater": "Nach Termin / Rechnung",
  "manual.notes": "Notiz / Anmerkung (INTERN)",
  "manual.notesPlaceholder": "Optionale Anmerkung zur Buchung… (INTERN)",
  "manual.notifyCustomer": "Kunde per E-Mail benachrichtigen",
  "manual.submit": "Manuelle Buchung anlegen",
  "manual.submitting": "Wird angelegt…",
  "manual.successKicker": "Buchung gespeichert",
  "manual.successTitle": "Manuelle Buchung angelegt",
  "manual.successLead":
    "Die Buchung für {{email}} wurde erfolgreich im Admin-Dashboard gespeichert.",
  "manual.successService": "Leistung",
  "manual.successNotification": "Benachrichtigung",
  "manual.successNotificationYes": "Kunde wurde per E-Mail informiert.",
  "manual.successNotificationNo": "Keine Kunden-E-Mail versendet.",
  "manual.successClose": "Alles klar",
  "manual.listTitle": "Manuelle Buchungen",
  "manual.listLead":
    "Alle manuell angelegten Buchungen, sortiert nach Termin (frühester zuerst). Status, interne Notizen und Stornierung wie bei den übrigen Buchungen.",

  "revenue.formLead":
    "Umsatz erfassen, der nicht über eine Buchung im System läuft — z. B. Barzahlung vor Ort oder nachträgliche Korrektur.",
  "revenue.formTitle": "Umsatzeintrag",
  "revenue.amount": "Betrag (€)",
  "revenue.amountRequired": "Bitte einen gültigen Betrag größer als 0 € angeben.",
  "revenue.date": "Datum",
  "revenue.dateRequired": "Bitte ein Datum angeben.",
  "revenue.massageType": "Massageart",
  "revenue.massageTypePlaceholder": "Keine Angabe",
  "revenue.submit": "Umsatz speichern",
  "revenue.submitting": "Wird gespeichert…",
  "revenue.submitError": "Der Umsatzeintrag konnte nicht gespeichert werden.",
  "revenue.success": "Umsatzeintrag gespeichert.",
  "revenue.listTitle": "Gespeicherte Einträge",
  "revenue.listLead": "Manuelle Umsatzeinträge nach Datum sortiert (neueste zuerst).",
  "revenue.loadError": "Einträge konnten nicht geladen werden.",
  "revenue.colDate": "Datum",
  "revenue.colAmount": "Betrag",
  "revenue.colType": "Massageart",
  "revenue.colCreated": "Erfasst am",
  "revenue.colActions": "Aktionen",
  "revenue.delete": "Löschen",
  "revenue.deleteTitle": "Umsatzeintrag löschen",
  "revenue.deleteConfirm": "{{amount}} vom {{date}} wirklich löschen?",
  "revenue.deleteError": "Eintrag konnte nicht gelöscht werden.",

  "comparison.lead":
    "Umsatz für einen Tag oder einen Zeitraum auswerten. Buchungen zählen am Termintag, manuelle Einträge am erfassten Datum.",
  "comparison.from": "Von",
  "comparison.to": "Bis",
  "comparison.apply": "Auswerten",
  "comparison.loading": "Wird geladen…",
  "comparison.loadError": "Umsatzvergleich konnte nicht geladen werden.",
  "comparison.dateRequired": "Bitte mindestens ein Startdatum angeben.",
  "comparison.dateHint":
    "Ein einzelner Tag: gleiches Datum bei Von und Bis. Mehrere Tage: Enddatum wählen. Die Auswertung aktualisiert sich automatisch.",
  "comparison.periodRange": "{{from}} – {{to}}",
  "comparison.totalRevenue": "Umsatz gesamt",
  "comparison.bookingRevenue": "Aus Buchungen",
  "comparison.manualRevenue": "Manuell erfasst",
  "comparison.dayCount": "{{count}} Tag(e)",
  "comparison.bookingCount": "{{count}} Buchung(en)",
  "comparison.manualCount": "{{count}} Eintrag/Einträge",
  "comparison.colDate": "Datum",
  "comparison.colBookings": "Buchungen",
  "comparison.colManual": "Manuell",
  "comparison.colTotal": "Gesamt",
  "comparison.totalRow": "Summe",

  "login.kicker": "Admin · Intern",
  "login.title": "Admin",
  "login.titleEm": "Login",
  "login.lead": "Melde dich mit deinem Admin-Konto an, um Buchungen und Kundendaten einzusehen.",
  "login.email": "E-Mail",
  "login.password": "Passwort",
  "login.submit": "Anmelden",
  "login.submitting": "Anmelden…",
  "login.forgotPassword": "Passwort vergessen?",
  "login.backToSite": "← Zur Website",
  "login.failed": "Login fehlgeschlagen.",
  "login.noAccess": "Dieses Konto hat keinen Zugriff auf das Admin-Dashboard.",

  "accessDenied.title": "Kein Zugriff",
  "accessDenied.lead":
    "Dieses Konto hat keinen Admin-Zugriff. Bitte melde dich mit einem Admin-Konto an oder wende dich an die Verwaltung.",

  "dashboard.kicker": "Intern · Dr. Hoffmann",
  "dashboard.title": "Admin",
  "dashboard.titleEm": "Dashboard",
  "dashboard.welcome": "Willkommen{{name}}. Hier siehst du Website-Aktivität, Termine und Kundendaten.",
  "dashboard.welcomeName": ", {{firstName}}",
  "dashboard.loadError": "Dashboard konnte nicht geladen werden.",
  "dashboard.notification.regionAria": "Neue Aktivität",
  "dashboard.notification.title": "Neue Aktivität",
  "dashboard.notification.clearAll": "Alle schließen",
  "dashboard.notification.dismiss": "Benachrichtigung schließen",
  "dashboard.notification.view": "Im Kalender ansehen",
  "dashboard.notification.newBooking":
    "Neue Buchung: {{service}} — {{name}}, {{when}} ({{status}})",
  "dashboard.notification.updatedBooking":
    "Buchung aktualisiert: {{service}} — {{name}}, {{when}} ({{status}})",

  "dateRange.label": "Zeitraum",
  "dateRange.all": "Gesamt",
  "dateRange.7d": "7 Tage",
  "dateRange.30d": "30 Tage",
  "dateRange.90d": "90 Tage",
  "dateRange.custom": "Zeitraum",
  "dateRange.from": "Von",
  "dateRange.to": "Bis",
  "dateRange.inPeriod": "im gewählten Zeitraum",
  "dateRange.fromDate": "ab {{date}}",
  "dateRange.toDate": "bis {{date}}",
  "dateRange.range": "{{from}} – {{to}}",

  "overview.loading": "Daten werden geladen…",
  "overview.noData": "Keine Daten verfügbar.",
  "overview.scopeNote.all":
    "Alle Buchungen.",
  "overview.scopeNote.drHoffmann":
    "Nur Buchungen über die Dr.-Hoffmann-Website (keine Tawan-Spa-Leistungen).",
  "overview.scopeNote.tawanSpa":
    "Nur Buchungen über die Tawan-Spa-Website (keine Dr.-Hoffmann-Leistungen).",

  "brandFilter.label": "Marke",
  "brandFilter.all": "Alle",
  "brandFilter.drHoffmann": "Dr. Hoffmann Massage",
  "brandFilter.tawanSpa": "Tawan Spa",
  "overview.stats.totalCustomers": "Kunden gesamt",
  "overview.stats.newInPeriod": "{{count}} neu {{period}}",
  "overview.stats.qrCustomers": "QR Kunden",
  "overview.stats.tawanQrCustomers": "Tawan QR Kunden",
  "overview.stats.emailVerified": "{{count}} E-Mail bestätigt",
  "overview.stats.totalBookings": "Buchungen gesamt",
  "overview.stats.upcomingToday": "{{upcoming}} kommend · {{today}} heute",
  "overview.stats.bookingsInPeriod": "Buchungen im Zeitraum",
  "overview.stats.bookings": "Buchungen",
  "overview.stats.revenueInPeriod": "Umsatz im Zeitraum",
  "overview.stats.revenueTotal": "Umsatz gesamt",
  "overview.stats.revenueHint":
    "Am Termin-/Eintragsdatum, ohne Stornos; inkl. manuelle Umsatzeinträge",
  "overview.stats.manualRevenuePart": "davon {{amount}} manuell erfasst",
  "overview.stats.registrationReminderSent": "Registrierungs-Erinnerungen",
  "overview.stats.registrationReminderClicks":
    "{{clicks}} eindeutige Klicks auf „Jetzt Termin sichern“ · {{rate}} Klickrate",
  "overview.customersBySource": "Kunden nach Quelle",
  "overview.bookingsBySource": "Buchungen nach Quelle",
  "overview.recentSignups": "Neue Registrierungen",
  "overview.recentSignupsPeriod": "Neue Registrierungen (Zeitraum)",
  "overview.recentBookings": "Letzte Buchungen",
  "overview.recentBookingsPeriod": "Letzte Buchungen (Zeitraum)",

  "source.website": "Webseite",
  "site.tawanSpa": "Tawan Spa",
  "site.drHoffmann": "Dr. Hoffmann Massage",
  "source.hoffmannQr": "Dr. Hoffmann QR",
  "source.tawanQr": "Tawan QR",
  "source.drHoffmann": "Dr. Hoffmann",

  "status.pendingEmailVerification": "Noch nicht verbindlich (E-Mail offen)",
  "status.pendingEmployee": "Wartet auf Bestätigung",
  "status.confirmed": "Bestätigt",
  "status.cancelled": "Storniert",
  "cancelledBy.customer": "durch Kunde (selbst)",
  "cancelledBy.admin": "durch Team (Dashboard)",
  "cancelledBy.staff": "durch Team (E-Mail-Link)",
  "cancelledBy.teamLegacy": "durch Team",
  "calendar.bookingDetail.cancelledBy": "Storniert durch",
  "calendar.bookingDetail.cancelledAt": "Storniert am",
  "status.completed": "Bezahlt",
  "status.noShow": "Nicht erschienen",

  "service.dr-hoffmann-consultation": "Lizenzpartner Erstbesuch",
  "service.dr-hoffmann-business-event": "WM-Aktion",
  "service.dr-hoffmann-studio": "Dr. Hoffmann Massage im Studio",
  "service.dr-hoffmann-mobile": "Dr. Hoffmann Massage Vor Ort",
  "service.dr-hoffmann-wakeup-studio": "Wake-Up im Studio",
  "service.dr-hoffmann-wakeup-onsite": "Wake-Up vor Ort",
  "service.dr-hoffmann-wakeup-onsite-voucher": "Wake-Up vor Ort",
  "service.dr-hoffmann-wakeup-plus-business": "Wake-Up+ für Unternehmen",
  "service.thai-massage": "Traditionelle Thai-Massage",
  "service.thai-oil-massage": "Thai Ölmassage",
  "service.hot-stone-massage": "Hot-Stone-Massage",
  "service.massagesessel": "Tawan Spa Massagesessel",

  "calendar.lead":
    "Termine als Tages-, Wochen- oder Monatsansicht. Wähle einen Tag, um die Buchungen zu sehen.",
  "calendar.viewAria": "Kalenderansicht",
  "calendar.view.day": "Tag",
  "calendar.view.week": "Woche",
  "calendar.view.month": "Monat",
  "calendar.weekRange": "{{from}} – {{to}}",
  "calendar.loadError": "Kalender konnte nicht geladen werden.",
  "calendar.legend": "Tag mit Termin(en) oder Umsatz",
  "calendar.daysWithBookings": "{{count}} Tag(e) mit Einträgen in diesem Monat",
  "calendar.noDayEntries": "Keine Termine oder Umsatzeinträge an diesem Tag.",
  "calendar.noAppointments": "Keine Termine an diesem Tag.",
  "calendar.revenueEntry": "Umsatz",
  "calendar.revenueNoType": "Keine Massageart angegeben",
  "calendar.revenueDetail.kicker": "Manueller Umsatz",
  "calendar.revenueDetail.title": "Umsatzeintrag",
  "calendar.revenueDetail.date": "Datum",
  "calendar.revenueDetail.amount": "Betrag",
  "calendar.revenueDetail.massageType": "Massageart",
  "calendar.revenueDetail.created": "Erfasst am",
  "calendar.appointments": "{{count}} Termin(e)",
  "calendar.prevMonth": "← Zurück",
  "calendar.nextMonth": "Weiter →",
  "calendar.closedDay": "Samstag und Sonntag geschlossen",
  "calendar.bookingDetail.title": "Buchungsdetails",
  "calendar.bookingDetail.start": "Beginn",
  "calendar.bookingDetail.end": "Ende",
  "calendar.bookingDetail.duration": "Dauer",
  "calendar.bookingDetail.location": "Ort",
  "calendar.bookingDetail.brand": "Marke",
  "calendar.bookingDetail.studioSchedule": "Studio-Zeitplan",
  "calendar.bookingDetail.studioThursday": "Nur Donnerstag",
  "calendar.bookingDetail.studioWeekday": "Mo–Fr (Wochentag)",
  "calendar.bookingDetail.option": "Gebuchte Option",
  "calendar.bookingDetail.created": "Gebucht am",
  "calendar.bookingDetail.cancellationReason": "Storno-Grund",
  "calendar.bookingDetail.customerNotes": "Anmerkungen",
  "calendar.bookingDetail.serviceAddress": "Einsatzadresse",
  "calendar.bookingDetail.addressNotes": "Hinweise zur Adresse",
  "calendar.bookingDetail.none": "—",
  "calendar.bookingDetail.hint": "Hinweis",
  "calendar.bookingDetail.pendingEmailVerification":
    "Diese Buchung ist noch nicht verbindlich (z. B. Hotel-Tablet / Leonardo Nikolai). Der Kunde hat die E-Mail-Adresse noch nicht bestätigt — der Termin wird erst danach offiziell übermittelt und unser Team per E-Mail informiert.",

  "bookings.lead":
    "Alle Buchungen verwalten. Status und interne Notizen können angepasst werden. Stornierte Buchungen blendest du über die Checkbox ein. Kundendaten sind schreibgeschützt.",
  "bookings.statusFilter": "Status",
  "bookings.includePast": "Vergangene Termine anzeigen",
  "bookings.showCancelled": "Stornierte Buchungen anzeigen",
  "bookings.loadError": "Buchungen konnten nicht geladen werden.",
  "bookings.saveError": "Speichern fehlgeschlagen.",
  "bookings.noShowTitle": "Als nicht erschienen markieren?",
  "bookings.noShowConfirm":
    "{{name}} · {{when}} — Der Kunde erhält eine E-Mail, dass er nicht zum Termin erschienen ist.",
  "bookings.noShowConfirmBtn": "Nicht erschienen bestätigen",
  "bookings.noShowBusy": "Wird gespeichert…",
  "bookings.notesError": "Notiz konnte nicht gespeichert werden.",
  "bookings.deleteError": "Buchung konnte nicht storniert werden.",
  "bookings.delete": "Stornieren",
  "bookings.deleteTitle": "Buchung stornieren",
  "bookings.deleteConfirm": "{{name}} · {{when}}",
  "bookings.deleteConfirmBtn": "Stornieren",
  "bookings.deleteBusy": "Wird storniert…",
  "bookings.deleteReasonLabel": "Grund für die Stornierung",
  "bookings.deleteReasonHint":
    "Der Grund wird dem Kunden in der Storno-E-Mail mitgeschickt — z. B. warum der Termin entfällt oder ein Alternativvorschlag.",
  "bookings.deleteReasonPlaceholder": "z. B. Termin entfällt — bitte neu buchen",
  "bookings.permanentDelete": "Endgültig löschen",
  "bookings.permanentDeleteTitle": "Buchung endgültig löschen",
  "bookings.permanentDeleteConfirm":
    "Diese Buchung wird unwiderruflich aus der Datenbank entfernt (nicht nur storniert). {{name}} · {{when}}",
  "bookings.permanentDeleteConfirmBtn": "Endgültig löschen",
  "bookings.permanentDeleteReasonLabel": "Grund (optional)",
  "bookings.permanentDeleteReasonHint":
    "Optional für interne Dokumentation.",
  "bookings.permanentDeleteReasonPlaceholder": "z. B. Testbuchung",
  "bookings.loading": "Buchungen werden geladen…",
  "bookings.empty": "Keine Buchungen gefunden.",
  "bookings.col.appointment": "Termin",
  "bookings.sort.appointmentAsc": "Nach Termindatum: frühester Termin zuerst",
  "bookings.sort.appointmentDesc": "Nach Termindatum: spätester Termin zuerst",
  "bookings.col.service": "Leistung",
  "bookings.col.customer": "Kunde",
  "bookings.col.price": "Preis",
  "bookings.col.payment": "Zahlung",
  "bookings.col.status": "Status",
  "bookings.col.customerNotes": "Anmerkungen",
  "bookings.col.notes": "Notiz (intern)",
  "bookings.col.actions": "Aktionen",
  "bookings.notesPlaceholder": "Interne Notiz…",
  "bookings.badge.freeTawan": "Gratis Tawan",
  "bookings.badge.manual": "Manuell",
  "bookings.pagination": "Seite {{page}} von {{pages}} ({{total}} gesamt)",

  "customers.lead":
    "Kundendaten sind nur zur Ansicht — Name, E-Mail und Telefon können hier nicht bearbeitet werden.",
  "customers.searchPlaceholder": "Name, E-Mail oder Telefon suchen…",
  "customers.loadError": "Kunden konnten nicht geladen werden.",
  "customers.detailError": "Kundendetails konnten nicht geladen werden.",
  "customers.loading": "Kunden werden geladen…",
  "customers.empty": "Keine Kunden gefunden.",
  "customers.bookingCount": "{{count}} Buchung(en)",
  "customers.selectHint": "Kunde auswählen, um Details zu sehen.",
  "customers.detailLoading": "Details werden geladen…",
  "customers.field.email": "E-Mail",
  "customers.field.phone": "Telefon",
  "customers.field.registered": "Registriert",
  "customers.field.source": "Quelle",
  "customers.field.registrationSite": "Webseite",
  "customers.field.freeChair": "Gratis-Sessel (Tawan)",
  "customers.freeChair.used": "Bereits genutzt",
  "customers.freeChair.available": "Noch verfügbar",
  "customers.field.emailVerified": "E-Mail bestätigt",
  "customers.field.referralLink": "Empfehlungslink",
  "customers.field.referralUses": "Link genutzt",
  "customers.field.referralBalance": "Empfehlungsguthaben",
  "customers.referralCreditTitle": "Guthaben hinzufügen",
  "customers.referralCreditLead":
    "Manuell Empfehlungsguthaben gutschreiben. Der Betrag kann nur für Massagen auf der Website eingelöst werden.",
  "customers.referralCreditAmount": "Betrag",
  "customers.referralCreditSubmit": "Guthaben hinzufügen",
  "customers.referralCreditSubmitting": "Wird hinzugefügt…",
  "customers.referralCreditError": "Guthaben konnte nicht hinzugefügt werden.",
  "customers.readonlyNote":
    "Nur Ansicht — Kundendaten können hier nicht geändert werden (außer Empfehlungsguthaben oben).",
  "customers.bookingHistory": "Buchungshistorie",
  "customers.noBookings": "Keine Buchungen.",
  "customers.permanentDelete": "Kunde endgültig löschen",
  "customers.permanentDeleteTitle": "Kunde endgültig löschen",
  "customers.permanentDeleteConfirm":
    "Kunde und alle zugehörigen Buchungen werden unwiderruflich gelöscht. {{name}} · {{when}}",
  "customers.permanentDeleteConfirmBtn": "Endgültig löschen",
  "customers.permanentDeleteReasonLabel": "Bestätigung (optional)",
  "customers.permanentDeleteReasonHint":
    "Diese Aktion kann nicht rückgängig gemacht werden.",
  "customers.permanentDeleteReasonPlaceholder": "z. B. Doppelkonto",
  "customers.deleteError": "Kunde konnte nicht gelöscht werden.",
  "customers.exportCsv": "CSV exportieren",
  "customers.exporting": "Export wird erstellt…",
  "customers.exportError": "CSV-Export fehlgeschlagen.",
};

export default de;
